import { transparentColors } from '@assets/styles/helpers/colors.styles'

const sideBarStyles = {
  boxSizing: 'border-box',
  zIndex: 7,
  height: '100%',
  position: 'fixed',
  top: 0,

  '& .MuiDrawer-paper': {
    boxSizing: 'border-box',
    padding: '1rem 1.5rem 1.5rem 1.5rem',
    background: transparentColors.blackShade6,
    backdropFilter: 'blur(4px)',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    transition: 'width 0.3s ease-in-out',
    overflow: 'hidden'
  }
}

export default sideBarStyles
